import axios from "axios";
import { API_URL } from "../constants/api";

const axiosClient = axios.create({
  baseURL: API_URL,
});

export default axiosClient;
